import { type UIMatch } from '@remix-run/react';

import { ocOffersWidgetScript } from '~/constants/scripts';

import { type loader } from './loader';

export const handle = {
	breadcrumb: (match: UIMatch<typeof loader>) => {
		if (!match.data) return null;

		const {
			mapping: { displayName },
		} = match.data;

		const { card, sport, subevent } = match.params;
		const href = `/${sport}/${card}/${subevent}`;
		const text = displayName;

		return {
			href,
			text,
		};
	},
	scripts: () => [ocOffersWidgetScript],
};
